// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
var partial$0 = require('./_modalDialogHeaderTemplate.hbs');
HandlebarsCompiler.registerPartial('./_modalDialogHeaderTemplate.hbs', partial$0);
var partial$1 = require('./_modalDialogContentTemplate.hbs');
HandlebarsCompiler.registerPartial('./_modalDialogContentTemplate.hbs', partial$1);
var partial$2 = require('./_modalDialogFooterTemplate.hbs');
HandlebarsCompiler.registerPartial('./_modalDialogFooterTemplate.hbs', partial$2);
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"./_modalDialogHeaderTemplate.hbs"),depth0,{"name":"./_modalDialogHeaderTemplate.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(lookupProperty(partials,"./_modalDialogContentTemplate.hbs"),depth0,{"name":"./_modalDialogContentTemplate.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(lookupProperty(partials,"./_modalDialogFooterTemplate.hbs"),depth0,{"name":"./_modalDialogFooterTemplate.hbs","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
